import { useEffect, useRef, useState } from 'react';
import { Contact } from './simulator.slice';
import classes from './simulator.module.scss';
import { Card, CardContent, Divider, Slide } from '@mui/material';
import { DigitalChannelType, MediaType } from '@nice-ccf/core-sdk';
import axios from 'axios';
import {
  CcfBox,
  CcfButton,
  CcfChatIcon,
  CcfSimulatorUploadIcon,
  CcfTypography,
  CcfCloseIcon,
} from '@nice-ccf/ui-controls';
import { generateRandomId, processResultToArray } from './simulator-util';
import { TransitionGroup } from 'react-transition-group';
import { CcfEmailProgressBar } from '@nice-ccf/ui-components';

/**
 *
 * @param props -
 * @example
 * @returns
 */
export default function CustomerChatData(props: {
  selectedContact: Contact;
  handleInputChange: any;
  broadCastCopilotData: any;
  isLiveCopilotEnabled: boolean;
  clearSimulatorClicked: boolean;
  setClearSimulatorClicked: any;
}) {
  const {
    selectedContact,
    handleInputChange,
    broadCastCopilotData,
    isLiveCopilotEnabled,
    clearSimulatorClicked,
    setClearSimulatorClicked,
  } = props;
  const [chatMessage, setChatMessage] = useState('');
  const fileUpload = useRef<any>(null);

  const [replyAttachmentList, setreplyAttachmentList] = useState(Array);

  useEffect(() => {
    if (clearSimulatorClicked) {
      setreplyAttachmentList([]);
      if (fileUpload?.current) {
        fileUpload.current.value = '';
      }
      setChatMessage('');
      setClearSimulatorClicked(false);
    }
  }, [clearSimulatorClicked]);

  /**
   * Function to handle Chat Message Input
   * @example - chatMessageHandler()
   */
  const chatMessageHandler = (e: any) => {
    setChatMessage(e.target.value);
  };

  /**
   * Function to handle Chat Message Input
   * @example - chatMessageHandler()
   */
  const handleSendReplyClick = () => {
    handleInputChange('customerChatReply', chatMessage);
    //handleButtonClick();
    //dispatch(updateCustomerChatJSONData(chatMessage));
  };

  /**
   * Function to get file info of attchment being uploaded
   * @example getFileInfo()
   */
  const getFileInfo = () => {
    // setProgress(0);
    const data = new FormData();
    data.append('file', fileUpload.current.files);
    const attachmentCopy = [];
    for (const item of fileUpload.current.files) {
      attachmentCopy.push({ name: item.name, progress: 0 });
    }
    setreplyAttachmentList([...replyAttachmentList, ...attachmentCopy]);
    setreplyAttachmentList((state) => {
      return state;
    });
    getFileContent();
    handleInputChange('customerChatReply', '');

    fileUpload.current.value = '';
  };

  /**
   * Function to get file content of JSON file being uploaded
   * @example getFileContent()
   */
  const getFileContent = () => {
    const file = fileUpload.current.files[0];
    const fr = new FileReader();
    fr.onload = receivedText;
    fr.readAsText(file);
  };

  /**
   * Function to receive text file content of json file being uploaded
   * @example receivedText()
   */
  const receivedText = (e: any) => {
    if (!isLiveCopilotEnabled) {
      const lines = e.target.result;
      const newArr = JSON.parse(lines);
      handleInputChange('customerChatReplyJsonData', newArr);
      const conversationData =
        selectedContact?.media === 'Voice'
          ? newArr.copilotAgentAndCustomerVoiceData
          : selectedContact?.media === MediaType.DIGITAL &&
            selectedContact?.channel === 'Chat'
          ? newArr.copilotAgentAndCustomerChatData
          : newArr.copilotAgentAndCustomerEmailData;
      const perviousInteractions = newArr.journeyHistory;
      const realTimeSummary = newArr.rtSummary;
      //const intents = newArr.copilotAgentAndCustomerChatData.intents;
      //const customReplies = newArr.customReplies;
      const autopilotSummary = newArr.autopilotSummary;
      const transferSummary = newArr.agentTransferSummary;
      const botTranscriptFile = newArr.botTranscriptData;
      const finalAutoSummary = newArr.finalAutoSummary;
      handleInputChange('customerChatReplyJsonData', conversationData);
      handleInputChange('perviousInteractionJsonData', perviousInteractions);
      handleInputChange('rtSummary', realTimeSummary);
      //handleInputChange('intents', intents);
      //handleInputChange('customReplies', customReplies);
      handleInputChange('autopilotSummary', autopilotSummary);
      handleInputChange('transferSummary', transferSummary);
      handleInputChange('botTranscriptData', botTranscriptFile);
      handleInputChange('autoSummaryText', finalAutoSummary);
      if (botTranscriptFile) {
        handleInputChange('botTranscript', true);
      }
    }
    if (isLiveCopilotEnabled) {
      const lines = e.target.result;
      const newArr = JSON.parse(lines);
      const dataFileArr = newArr.dataFile;
      const audioFileName = newArr.audioFileName;
      const customerName = newArr.customerFullName;
      const agentName = newArr.agentName;
      const perviousInteractions = newArr.interactions;
      const intents = newArr.intents;
      const customReplies = newArr.customReplies;
      const autopilotSummary = newArr.autopilotSummary;
      const transferSummary = newArr.transferSummary;
      const customerSentiment = newArr.customerSentiment;
      const confidence = newArr.confidence;
      const id = generateRandomId(agentName, customerName);
      const processedArray = processResultToArray(
        dataFileArr,
        selectedContact.media,
        agentName
      );
      const emailId = newArr.emailId;
      const emailSubject = newArr.emailSubject;
      const receiverEmail = newArr.receiverEmail;
      const attachments = newArr.attachments;

      handleInputChange('customerChatReplyJsonData', processedArray);
      handleInputChange('perviousInteractionJsonData', perviousInteractions);
      handleInputChange('intents', intents);
      handleInputChange('customReplies', customReplies);
      handleInputChange('customerSentiment', customerSentiment);
      handleInputChange('confidence', confidence);
      handleInputChange('audioFileName', audioFileName);
      handleInputChange('customerName', customerName);
      handleInputChange('firstName', customerName.split(' ')[0]);
      handleInputChange('lastName', customerName.split(' ')[1]);
      handleInputChange('autopilotSummary', autopilotSummary);
      handleInputChange('transferSummary', transferSummary);
      handleInputChange('emailId', emailId);
      handleInputChange('emailSubject', emailSubject);
      handleInputChange('receiverEmail', receiverEmail);
      handleInputChange('attachments', attachments);
      selectedContact?.channel === 'Email'
        ? handleInputChange('channel', DigitalChannelType.EMAIL)
        : handleInputChange('channel', DigitalChannelType.CHAT);
      handleInputChange('id', id);
    }
  };

  /**
   * function  to remove attachment
   * @param param0 - param
   * @example attachmentRemoveHandler()
   * @returns
   */
  function attachmentRemoveHandler(attachmentItem: any) {
    const updatedAttachmentList = replyAttachmentList.filter(
      (attach: any) => attach.name !== attachmentItem
    );
    setreplyAttachmentList(updatedAttachmentList);
    if (fileUpload?.current) {
      fileUpload.current.value = '';
    }
  }

  /**
   * function  for Attachment Progress bar
   * @param param0 - progressValue
   * @param param1 - attachmentId
   * @example progressCallback(30,1)
   * @returns
   */
  function progressCallback(progressValue: any, attachmentId: number) {
    setreplyAttachmentList(
      replyAttachmentList.map((attachment: any, index: number) => {
        if (index === attachmentId) {
          // if(progressValue === 100) {
          //   const jsonChatData = JSON.parse(attachment);
          //   dispatch(updateCustomerChatJSONData(jsonChatData));
          // }
          return { ...attachment, progress: progressValue };
        }
        return attachment;
      })
    );
    setreplyAttachmentList((state) => {
      return state;
    });
  }

  /**
   * Function to download JSON file template
   * @example - downloadChatJsonFile()
   */
  const downloadChatJsonFile = () => {
    const fileName =
      selectedContact.channel === 'Chat' &&
      selectedContact.copilotAssist === 'Yes' &&
      selectedContact.copilotSource === 'JSON'
        ? 'CopilotChatData.json'
        : selectedContact.channel === 'Chat' &&
          selectedContact.copilotAssist === 'Yes' &&
          selectedContact.copilotSource === 'Live LLM'
        ? 'oneAppliance_chat.json'
        : selectedContact?.media === MediaType.VOICE &&
          selectedContact.copilotAssist === 'Yes' &&
          selectedContact.copilotSource === 'JSON'
        ? 'CopilotVoiceData.json'
        : selectedContact?.media === MediaType.VOICE &&
          selectedContact.copilotAssist === 'Yes' &&
          selectedContact.copilotSource === 'Live LLM'
        ? 'onetelecomvoice.json'
        : 'ChatData.json';
    axios({
      url: './../assets/' + fileName,
      method: 'GET',
      responseType: 'blob',
    })
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  return (
    <Card className={classes.heightInherit}>
      <CardContent>
        <form
          className={classes.root + ' ' + classes.simulatorForm}
          noValidate
          autoComplete="off"
        >
          <CcfTypography className={classes.txtChatMsg}>
            CUSTOMER CHAT SIMULATOR
          </CcfTypography>
          <CcfTypography className={classes.headingSubText}>
            Type a test chat below for the simulator. For bulk chats, use the
            template.
          </CcfTypography>
          <Divider
            style={{ background: '#F0F0F0', height: '1px', width: '100%' }}
          />
          <CcfBox className={classes.mainDivBlock}>
            <CcfBox
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <CcfChatIcon
                style={{ height: '20px', width: '20px', marginTop: '6px' }}
              />
              <CcfTypography className={classes.txtChat}>Chat</CcfTypography>
            </CcfBox>
            <textarea
              rows={7}
              id={`sm_copilot_customerChat_textArea`}
              cols={21}
              disabled={replyAttachmentList?.length > 0}
              placeholder="Type a message here"
              className={classes.textAreaInput}
              value={chatMessage}
              onChange={(event) => chatMessageHandler(event)}
            />
            <CcfBox
              className={
                replyAttachmentList?.length > 0
                  ? classes.uploadedFileBox
                  : classes.uploadFileBox
              }
              style={{ cursor: chatMessage ? 'not-allowed' : 'pointer' }}
            >
              {replyAttachmentList?.length === 0 && (
                <div className={classes.uploadFileInnerBox}>
                  <input
                    type="file"
                    id={`sm_copilot_customerChat_uploadTemplate`}
                    hidden
                    ref={fileUpload}
                    multiple
                    onChange={getFileInfo}
                    disabled={chatMessage.length > 0}
                  />
                  <CcfSimulatorUploadIcon
                    onClick={() => {
                      fileUpload.current.click();
                    }}
                  />
                  <CcfTypography className={classes.txtUploadTemplate}>
                    Upload template
                  </CcfTypography>
                </div>
              )}
              {replyAttachmentList.length > 0 && (
                <TransitionGroup>
                  <CcfTypography className={classes.txtFile}>
                    File:
                  </CcfTypography>
                  {replyAttachmentList.map(
                    (attachmentItem: any, index: number) => {
                      return (
                        <Slide key={index} direction={'left'} timeout={500}>
                          <div
                            className={classes.attachmentBox}
                            style={{
                              width: '100%',
                            }}
                            key={index}
                          >
                            <CcfTypography
                              className={
                                attachmentItem.progress === 100
                                  ? classes.fileNameUploaded
                                  : classes.fileNameInBlack
                              }
                              style={{
                                width: '100%',
                              }}
                            >
                              {attachmentItem.name}
                            </CcfTypography>
                            <CcfEmailProgressBar
                              attachmentId={index}
                              progressCallback={progressCallback}
                            />
                            <CcfCloseIcon
                              className={classes.attachmentCloseIcon}
                              onClick={() => {
                                attachmentRemoveHandler(attachmentItem.name);
                              }}
                            />
                          </div>
                        </Slide>
                      );
                    }
                  )}
                </TransitionGroup>
              )}
            </CcfBox>
            <CcfBox className={classes.clickHereStatement}>
              <span
                style={{
                  color: '#007AB8',
                  textDecorationLine: 'underline',
                }}
                onClick={downloadChatJsonFile}
                id={`sm_copilot_customerChat_downloadTemplate`}
              >
                Click here
              </span>
              &nbsp; to download template to create bulk chats.
            </CcfBox>
            <CcfBox className={classes.btnBox}>
              <CcfButton
                className={`${classes.btn} ${classes.CancelButton}`}
                id={`sm_copilot_customerChat_cancel_button`}
              >
                <CcfTypography
                  className={`${classes.btnText} ${classes.txtCancel}`}
                >
                  Cancel
                </CcfTypography>
              </CcfButton>
              <CcfButton
                primary
                className={`${classes.btn} ${classes.saveButton}`}
                disabled={!chatMessage}
                id={`sm_copilot_customerChat_send_button`}
                onClick={(e) => {
                  handleSendReplyClick();
                  if (isLiveCopilotEnabled) {
                    setTimeout(() => {
                      broadCastCopilotData(chatMessage);
                    });
                  }
                }}
              >
                <CcfTypography
                  className={`${classes.btnText} ${
                    chatMessage ? classes.txtSave : classes.txtSaveDisabled
                  }`}
                >
                  Send
                </CcfTypography>
              </CcfButton>
            </CcfBox>
          </CcfBox>
        </form>
      </CardContent>
    </Card>
  );
}
